import { QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUser, updateUserQuery } from '../services/authService';
import { queryKeys } from './queryKeys';
import { UserDoc, withUserFields } from './userTransforms';

// The signed-in person's own account. `data` is null when the account has no access to this page.

export const userOptions = () => ({
    queryKey: queryKeys.user(),
    queryFn: () => getUser(),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
});

export const useUser = () => useQuery(userOptions());

export const updateUserMutation = (queryClient: QueryClient) => ({
    mutationFn: (fields: Required<UserDoc>) => updateUserQuery(fields),
    onSuccess: (_result: unknown, fields: Required<UserDoc>) => {
        queryClient.setQueryData<UserDoc | null>(queryKeys.user(), (user) => withUserFields(user, fields));
    },
});

export const useUpdateUser = () => useMutation(updateUserMutation(useQueryClient()));
